import {nonEmpty} from '@lib/utils';
import {isSameDay, parseISO} from 'date-fns';
import {CalendarDay} from '../../../data/calendar/types';
import {UICalendarDay} from '../types';

export const toUICalendarDay = ({date, weekNumber}: CalendarDay, today: string): UICalendarDay => ({
  date,
  weekNumber,
  isToday: isSameDay(parseISO(date), parseISO(today)),
});

export const toUICalendarDays = (days: (CalendarDay | undefined)[], today: string): UICalendarDay[] =>
  nonEmpty(days).map((day) => toUICalendarDay(day, today));
